import {EksternProtokollførtMøtedeltakerModell, ProtokollførtMøtedeltakereModell, ProtokollførtMøtedeltakerModell} from "../tjenester/ressurser/generertNg2HttpKlient";

export function signatarer(protokollførteDeltakere: ProtokollførtMøtedeltakereModell): ProtokollførtMøtedeltakerModell[] {
    return [...protokollførteDeltakere.deltatte, ...protokollførteDeltakere.forfalte, ...protokollførteDeltakere.ikkeInnkalte]
      .filter(deltaker => deltaker.skalSignere)
}

export function signatarerSomIkkeHarSignert(protokollførteDeltakere: ProtokollførtMøtedeltakerModell[]): ProtokollførtMøtedeltakerModell[] {
    return protokollførteDeltakere.filter(deltaker => deltaker.skalSignere && !deltaker.harSignert);
}

export function signatarerSomHarSignert(protokollførteDeltakere: ProtokollførtMøtedeltakerModell[]): ProtokollførtMøtedeltakerModell[] {
    return protokollførteDeltakere.filter(deltaker => deltaker.skalSignere && deltaker.harSignert);
}

/** Returnerer en liste med deltatt, forfalt og ikke-innkalt deltakere fra angitt protokollførteDeltakere. */
export function interneProtokollførteMøtedeltakere(protokollførteDeltakere: ProtokollførtMøtedeltakereModell): ProtokollførtMøtedeltakerModell[] {
    return [...protokollførteDeltakere.deltatte, ...protokollførteDeltakere.forfalte, ...protokollførteDeltakere.ikkeInnkalte];
}

/** Returnerer en liste med eksterne deltakere fra angitt protokollførteDeltakere. */
export function eksterneProtokollførteMøtedeltakere(protokollførteDeltakere: ProtokollførtMøtedeltakereModell): EksternProtokollførtMøtedeltakerModell[] {
    return [...protokollførteDeltakere.eksterne];
}
